module.exports = __webpack_public_path__ + "img/bus-warbe.91119014.png";